<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
            <el-form-item label="活动名称">
                <el-input v-model="queryForm.activityName"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getShopClassifyList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button type="primary" size="small" icon="el-icon-plus" @click="addShopClassify">新建</el-button>
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editShopClassify(null)"
                    >修改</el-button
                    >
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteShopClassify(null)"
                    >删除</el-button
                    >
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate" class="upload-demo" action="#" :http-request="upload" :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span class="icon-box" @click="refreshShopClassifyList">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="shopClassifyList"
                row-key="id"
                border
                :header-row-style="{ height: '10px' }"
                :header-cell-style="{ padding: '10px' }"
                :row-style="{ height: '9px' }"
                :cell-style="{ padding: '9px' }"
                @selection-change="handleSelectionChange"
                size="small"
                height="100%"
            >
                <el-table-column align="center" type="selection" width="60"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="activityName" label="活动名称" min-width='100'> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="id" label="活动ID" min-width='300'> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="activityPic" label="活动封面" min-width="100">
                    <template slot-scope="scope">
                        <div v-if="scope.row.activityPic">
                            <el-image
                                @click='updateSrcList(scope.row.activityPic)'
                                style=" height: 30px"
                                :src="scope.row.activityPic"
                                :preview-src-list="srcList"
                            > </el-image>
                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="activityLink" label="活动链接"  min-width='200'> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="sort" label="活动排序" min-width="100"> </el-table-column>
                <el-table-column fixed="right" align="center" label="操作" width="460">
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="openList(scop.row.id)">
                                <!-- <Icon size="16" style="color: #340000">
                                    <Edit24Regular />
                                </Icon> -->
                                <i class="el-icon-folder-opened" size="16"></i>
                                <span class="operation-label"> 管理商品</span>
                            </div>
                            <div @click="openShop(scop.row.id)">
                                <!-- <Icon size="16" style="color: #efc58b">
                                    <Edit24Regular />
                                </Icon> -->
                                <i class="el-icon-circle-plus-outline" size="16"></i>
                                <span class="operation-label"> 批量添加商品</span>
                            </div>
                            <div @click="checkShopClassify(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editShopClassify(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteShopClassify(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                            <div @click="addBanner(scop.row.id)">
                                <i class="el-icon-folder-opened" size="16"></i>
                                <span class="operation-label">轮播图</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog :title="shopClassifyStates[shopClassifyState]" :visible.sync="showDialog" width="400px" @close="closeDialog">
                <div>
                    <el-form :model="shopClassify" ref="shopClassifyForm" :rules="rules" :inline="true" size="small">
                        <el-form-item label="活动名称" prop="activityName">
                            <el-input
                                size="small"
                                v-model="shopClassify.activityName"
                                style="width: 200px"
                                :disabled="shopClassifyState == 'check'"
                            ></el-input>
                        </el-form-item>

                        <el-form-item label="活动链接" prop="activityLink">
                            <pathselect
                                style="width: 200px"
                                :disabled="shopClassifyState == 'check'"
                                :value="shopClassify.activityLink"
                                @change="changePathSelect"
                            ></pathselect>
                        </el-form-item>

                        <el-form-item label="活动排序" prop="sort">
                            <el-input
                                size="small"
                                v-model="shopClassify.sort"
                                style="width: 200px"
                                :disabled="shopClassifyState == 'check'"
                            ></el-input>
                        </el-form-item>

                        <el-form-item label="活动封面" prop="activityPic" label-width="80px">
                            <el-upload
                                action=""
                                :disabled="shopClassifyState == 'check'"
                                class="avatar-uploader"
                                :show-file-list="false"
                                :http-request="uploadAvatar"
                                style="width: 200px"
                            >
                                <img v-if="shopClassify.activityPic" :src="shopClassify.activityPic" class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                </div>

                <div slot="footer" class="flex justify-end">
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button type="primary" @click="submitForm" v-if="shopClassifyState != 'check'">确定</el-button>
                </div>
            </el-dialog>

            <!-- 添加商品 -->
            <el-dialog title="批量添加商品" :visible.sync="showAdd" width="400px" @close="closeShop">
                <div>
                    <el-form :model="shopProductClassify" ref="shopProductClassifyForm" :rules="rules" :inline="true" size="small">
                        <el-form-item label="商品" prop="productIdList">
                            <div style="display: flex;">
                                <GridSelectLi
                                ref="add1"
                                style="width: 200px"
                                title="选择商品"
                                labelName="productName"
                                labelValue="id"
                                :did="did"
                                :value="shopProductClassify.productId"
                                :limit="99"
                                size="small"
                                placeholder="请选择商品"
                                @getValue="getValuebrandId"
                                :columns="PRODUCT_code"
                                :searchs="PRODUCT_search"
                                dataListUrl="/shop/product/findList"
                                entityBeanName="shopProduct"
                                queryEntityUrl="/shop/product/get"
                            >
                            </GridSelectLi>
                            <el-button style="height: 30px;margin: 0 4px;" type="primary" @click="add1">添加</el-button>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>

                <div slot="footer" class="flex justify-end">
                    <el-button @click="closeShop">关闭</el-button>
                    <el-button type="primary" @click="shopaddForm">确定</el-button>
                </div>
            </el-dialog>

            <!-- 弹窗商品列表 -->
            <el-dialog title="商品列表" :visible.sync="shopList" width="1200px">
                <!-- <shop-product-catalog-list :id="this.shopListForm.activityId"></shop-product-catalog-list> -->
                <el-button
                    type="danger"
                    plain
                    size="small"
                    icon="el-icon-delete"
                    :disabled="multipleSelection.length <= 0"
                    @click="deleteShopProductClassify(null)"
                >删除</el-button
                >
                <el-table
                    :data="shopProductClassifyList"
                    row-key="id"
                    border
                    @selection-change="handleSelectionChange"
                    height="500px"
                    size="small"
                >
                    <el-table-column align="center" type="selection" width="60"> </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="center" prop="activityName" label="商品活动"> </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="center" prop="productName" label="商品名称"> </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="center" prop="productPic" label="商品图片">
                        <template slot-scope="scope">
                            <div v-if="scope.row.productPic">
                                <div vertical-align:middle>
                                    <img
                                        style="margin-left: 50%; transform: translate(-50%, 0)"
                                        :src="scope.row.productPic"
                                        alt=""
                                        class="w-15 h-20 log-img"
                                    />
                                </div>
                            </div>
                            <div v-else>--</div>
                        </template>
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="center" prop="shopPrice" label="商品价格"> </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" align="center" prop="createTime" label="更新时间"> </el-table-column>
                    <el-table-column fixed="right" align="center" label="操作" width="200">
                        <template slot-scope="scop">
                            <div class="operation">
                                <div @click="update(scop.row.id)">
                                    <i class="el-icon-refresh"></i>
                                    <span class="operation-label" style="color: #409eff">更新</span>
                                </div>
                                <div @click="deleteShopProductClassify(scop.row.id)">
                                    <Icon size="16" style="color: red">
                                        <Delete24Regular />
                                    </Icon>

                                    <span class="operation-label" style="color: red">删除</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-box">
                    <el-pagination
                        @size-change="sizeChanges"
                        @current-change="currentChanges"
                        :current-page.sync="currentPages"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSizes"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalNums"
                        background
                        :pager-count="7"
                    >
                    </el-pagination>
                </div>
            </el-dialog>

            <!-- 轮播图列表 -->
            <el-dialog title="轮播图" :visible.sync="showBanner" width="60%">
                <ShopActivityBanner ref="banner" style="height: 500px"></ShopActivityBanner>
                <div slot="footer" class="flex justify-end">
                    <el-button @click="closeBanner">关闭</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import ShopActivityBanner from '@/components/shop/ShopActivityBanner.vue';
import Pathselect from '@/components/pathselect/pathselect.vue';
// import ShopProductCatalogList from './shopProductCatalogList.vue';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import { PRODUCT,PRODUCT_SEARCH } from '@/utils/constant.js'

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        GridSelectLi,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        ShopActivityBanner,
        Pathselect
        // ShopProductCatalogList
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopClassifyList();
                this.getShopClassifyList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopClassifyList();
                this.getShopClassifyList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            did: '',
            cid: '',
            shopListForm: {
                activityId: '',
                productName: '', //商品id
                activityName: '' //类别类型
            },
            dialogVisible: false,
            queryForm: {
                activityName: '', //名称
                activityPic: '' //封面
            },
            PRODUCT_code:PRODUCT,
            PRODUCT_search: PRODUCT_SEARCH,
            shopProductClassify: {
                id: '', //id
                productIdList: [], //商品id
                activityId: '' //类别类型
            },
            shopProductClassifyList: [],
            loading: false,
            shopList: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            showAdd: false,
            pageSize: 10,
            pageSizes: 10,
            currentPage: 1,
            currentPages: 1,
            totalNum: 0,
            totalNums: 0,
            currentUserId: '',
            shopClassifyState: 'add',
            shopClassifyStates: {
                add: '新建分类活动',
                check: '查看分类活动',
                edit: '修改分类活动'
            },

            multipleSelection: [],
            shopClassifyList: [],
            shopClassify: {
                // id: '', //ID
                activityName: '', //名称
                activityPic: '', //封面
                activityLink: '',
                sort: ''
            },
            btnLoading: false,

            rules: {
                // id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                activityName: [{ required: true, message: '活动名称不能为空', trigger: 'blur' }],
                activityPic: [{ required: true, message: '活动封面不能为空', trigger: 'blur' }],
                activityLink: [{ required: true, message: '活动链接不能为空', trigger: 'blur' }],
                productIdList: [{ required: true, message: '商品不能为空', trigger: 'blur' }],
                sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }]
            },
            srcList:[''],//大图预览


            showBanner: false,
        };
    },
    created() {
        this.getShopClassifyList();
    },
    methods: {
        addBanner(id){
            this.showBanner = true;
            this.$nextTick(()=>{
                this.$refs.banner.init(id)
            })
        },
        closeBanner(){
            this.showBanner = false;
        },

        changePathSelect(path) {
            this.shopClassify.activityLink = path;
        },

        add1(){
            this.$refs.add1.showSelectDialog();
            console.log(this.$refs.add1)
        },
        getValuebrandId(value) {
            console.log('1111111111111111111111111111111111111111111')
            this.shopProductClassify.productIdList = value;

            // console.log('1111111',this.shopProductClassify.productIdList)
            // console.log('2222222',this.shopProductClassify.productId)
        },
        uploadAvatar(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!types.includes(file.type)) {
                this.$message({
                    message: '只能上传图片格式的文件，png.jpg或者jpeg',
                    type: 'error',
                    showClose: true,
                    duration: 2000
                });
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload(`/mpp/image/upload`, formData).then((res) => {
                console.log({ res });
                if (res.success) {
                    this.shopClassify.activityPic = res.url;
                }
            });
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopClassifyList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopClassifyList = [];
        },
        resetDialog() {
            this.shopClassifyState = 'add';
            this.showDialog = false;
            this.queryForm = {
                // id: '', //ID
                activityName: '', //名称
                activityPic: '' //封面
            };
            this.getShopClassifyList();
        },
        closeDialog() {
            this.shopClassify = {
                // id: '', //ID  shopClassify
                activityName: '', //名称
                activityPic: '', //封面
                activityLink: '',
                sort: ""
            };
            this.showDialog = false;
            this.$refs.shopClassifyForm.resetFields();
        },
        closeShop() {
            this.shopProductClassify = {
                // id: '', //id
                productId: [], //商品id
                activityId: '' //类别类型
            };
            this.$refs.shopProductClassifyForm.resetFields();
            this.showAdd = false;
        },
        //更新
        update(id) {
            post(`shop/activityproduct/updateCreateTime`, { id }).then((res) => {
                if (res.success) {
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        duration: 2000
                    });
                }
                this.openList(this.cid);
            });
        },
        submitForm() {
            if (this.shopClassifyState == 'add') {
                this.$refs.shopClassifyForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/activity/add`, { ...this.shopClassify }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopClassifyList();
                                this.resetDialog();
                                this.getShopClassifyList();
                            }
                        });
                    }
                });
            } else if (this.shopClassifyState == 'edit') {
                this.$refs.shopClassifyForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/shop/activity/edit`, { ...this.shopClassify }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopClassifyList();
                                this.resetDialog();
                                this.getShopClassifyList();
                            }
                        });
                    }
                });
            }
        },
        overShop(id) {
            //查看
            console.log(id);
            this.$router.push({
                path: '/shop/activityproduct',
                query: { typeId: id, viewDetails: '1' }
            });
        },
        //添加商品信息
        openShop(id) {
            this.showAdd = true;
            console.log(id);
            this.shopProductClassify.activityId = id;
            this.did = id;
            console.log(this.did);
            console.log(this.shopProductClassify);
        },
        shopaddForm() {
            this.$refs.shopProductClassifyForm.validate((valid) => {
                if (valid) {
                    console.log('submit');
                    console.log(this.shopProductClassify);
                    // console.log(this.shopProductClassifyList);
                    post(`/shop/activityproduct/addBatch`, { ...this.shopProductClassify }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.closeShop();
                        }
                    });
                }
            });
        },
        //商品列表
        openList(id) {
            this.shopProductClassifyList = [];
            this.shopList = true;
            this.loading = true;
            this.shopListForm.activityId = id;
            get(`/shop/activityproduct/findList`, {
                ...this.shopListForm,
                pageNum: this.currentPages,
                pageSize: this.pageSizes
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    console.log(res.page.list);
                    this.totalNums = 0;
                    this.shopProductClassifyList = res.page.list;
                    console.log(this.shopProductClassifyList[0].activityId);
                    this.cid = this.shopProductClassifyList[0].activityId;
                    this.totalNums = res.page.total;
                }
            });
        },
        //删除
        deleteShopProductClassify(shopProductClassifyId) {
            let ids = '';
            if (shopProductClassifyId) {
                ids = shopProductClassifyId;
            } else {
                ids = this.multipleSelection.map((shopProductClassify) => shopProductClassify.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/activityproduct/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            console.log(this.cid);
                            this.openList(this.cid);
                        }
                    });
                })
                .catch(() => {});
        },
        addShopClassify() {
            this.showDialog = true;
            this.shopClassifyState = 'add';
        },
        checkShopClassify(shopClassifyId) {
            console.log(shopClassifyId);
            this.currentShopClassifyId = shopClassifyId;

            this.getShopClassifyById();
            this.showDialog = true;
            this.shopClassifyState = 'check';
        },
        editShopClassify(shopClassifyId) {
            console.log('shopClassify', shopClassifyId);
            if (shopClassifyId) {
                this.currentShopClassifyId = shopClassifyId;
                this.getShopClassifyById();
            } else {
                this.shopClassify = { ...this.shopClassify, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopClassifyState = 'edit';
        },
        deleteShopClassify(shopClassifyId) {
            let ids = '';
            if (shopClassifyId) {
                ids = shopClassifyId;
            } else {
                ids = this.multipleSelection.map((shopClassify) => shopClassify.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/shop/activity/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopClassifyList();
                            this.getShopClassifyList();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshShopClassifyList() {
            this.resetShopClassifyList();
            this.getShopClassifyList();
        },
        getShopClassifyList(query = {}) {
            this.loading = true;
            get(`/shop/activity/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then(
                (res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopClassifyList = res.page.list;
                        console.log(this.shopClassifyList);
                        this.totalNum = res.page.total;
                    }
                }
            );
        },
        getShopClassifyById() {
            get(`/shop/activity/get`, { id: this.currentShopClassifyId }).then((res) => {
                if (res.success) {
                    this.shopClassify = { ...this.shopClassify, ...res.shopClassify };
                }
            });
        },
        /**
         * 导出信息
         */
        // exportShopClassifyList() {
        //     //this.btnLoading = true;
        //     exprotExcel(`/mpp/shopclassify/export`, { ...this.queryForm });
        // },
        /**
         * 导出模板
         */
        // importTemplate() {
        //     this.btnLoading = true;
        //     importTemplate(`/mpp/shopclassify/importTemplate`, this.btnLoading);
        // },
        /**
         * 导入数据
         */
        // isImport() {
        //     this.isImportDate = !this.isImportDate;
        // },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/shop/activity/importData`, formData);
            this.refreshShopClassifyList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopClassifyList();
        },
        currentChanges(page) {
            // console.log(page);
            this.currentPages = page;
            // console.log(this.cid);
            this.openList(this.cid);
        },

        sizeChange(size) {
            this.pageSize = size;
            this.getShopClassifyList();
        },
        sizeChanges(size) {
            // console.log(size);
            this.pageSizes = size;
            console.log(this.cid);
            this.openList(this.cid);
        },
        updateSrcList(src){
            this.srcList[0] = src
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-upload--text {
    width: 200px;
}
// ::v-deep .log-img {
//     margin: 0 auto;
// }
.el-icon-plus {
    margin-top: 38%;
    font-size: 25px;
}
// ::v-deep .el-table__body-wrapper{
//     height: 484px;
// }
:v-deep .el-dialog {
    margin-top: 5vh;
}
</style>
